var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg-icon',_vm._b({attrs:{"data":require('@icon/ionicons/card-outline.svg'),"outlined":""}},'svg-icon',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }